export const isEmptyPinnedCell = (params, accessor) => params?.data?.$inserted && !params.data?.[accessor]

const handleInsertedCompare = (a, b, nodeA, nodeB, isDescending) => {
  if (nodeA?.data?.$inserted && nodeB?.data?.$inserted) {
    return 0
  }
  if (nodeA?.data?.$inserted && isDescending) {
    return 1
  }
  if (nodeA?.data?.$inserted) {
    return -1
  }
  if (nodeB?.data?.$inserted && isDescending) {
    return -1
  }
  if (nodeB?.data?.$inserted) {
    return 1
  }
  return 'no matches'
}

export const stringComparator = (a, b, nodeA, nodeB, isDescending) => {
  const earlyReturn = handleInsertedCompare(a, b, nodeA, nodeB, isDescending)
  if (earlyReturn === 'no matches') {
    return a?.toLowerCase().localeCompare(b?.toLowerCase())
  } else {
    return earlyReturn
  }
}

export const numberComparator = (a, b, nodeA, nodeB, isDescending) => {
  const earlyReturn = handleInsertedCompare(a, b, nodeA, nodeB, isDescending)
  if (earlyReturn === 'no matches') {
    return parseInt(a) > parseInt(b) ? 1 : -1
  } else {
    return earlyReturn
  }
}
